import { render, staticRenderFns } from "./AccountPairModal.vue?vue&type=template&id=ff6ef236"
import script from "./AccountPairModal.vue?vue&type=script&lang=js"
export * from "./AccountPairModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports